import "vite/modulepreload-polyfill";
import Masonry from "masonry-layout";
import Swiper from "swiper";
import "../internal-libs/iFrameSync/parent.js";
import "../utils/hotspotSvgUtils";
import "iframe-resizer";

window.Swiper = Swiper;
window.Masonry = Masonry;
// ---------------------------------------------------------------------------
// ES6 modules — explicit imports for all components, for better static analysis and testability.
// ---------------------------------------------------------------------------

// atoms
import { PageController } from "../../../_patterns/01-atoms/_page-controller/PageController";

// molecules
import { TrackingController } from "../../../_patterns/02-molecules/tracking-controller/TrackingController";
import { MapModule } from "../../../_patterns/02-molecules/map/MapModule";
import { CourseFormFooter } from "../../../_patterns/02-molecules/course-form-footer/CourseFormFooter";
import { CourseSession } from "../../../_patterns/02-molecules/course-session/CourseSession";
import { NavFlyout } from "../../../_patterns/02-molecules/nav-flyout/NavFlyout";
import { ShellNavigation } from "../../../_patterns/02-molecules/shellnavigation/ShellNavigation";
import { AnchorNavigationController } from "../../../_patterns/02-molecules/anchor-navigation/AnchorNavigationController";
import { LightboxController } from "../../../_patterns/02-molecules/lightbox-controller/LightboxController";

// components
import { ArticleList } from "../../../_patterns/03-components/article-list/ArticleList";
import { V2Searchfield } from "../../../_patterns/03-components/v2-searchfield/V2Searchfield";
import { initComponents as initRotatorSectionRows } from "../../../_patterns/03-components/rotator-section/RotatorSection";
import { initComponents as initChannelList } from "../../../_patterns/03-components/channel-list/ChannelList";
import { initComponents as initAuthorList } from "../../../_patterns/03-components/author-list/AuthorList";
import { CtaUtmsContainer } from "../../../_patterns/03-components/cta-utms-container/CtaUtmsContainer";
import { DisclaimerPopup } from "../../../_patterns/03-components/disclaimer-popup/DisclaimerPopup";
import { CourseDetailV2 } from "../../../_patterns/03-components/course-detail-v2/CourseDetailV2";
import { IFrame } from "../../../_patterns/03-components/iframe/IFrame";
import { Html5Module } from "../../../_patterns/03-components/html5module/Html5Module";
import { ShareButtons } from "../../../_patterns/03-components/share-buttons/ShareButtons";
import { SiteSelector } from "../../../_patterns/03-components/site-selector/SiteSelector";
import { BlurbV2 } from "../../../_patterns/03-components/blurb-v2/BlurbV2";
import { ButtonGroup } from "../../../_patterns/03-components/buttongroup/ButtonGroup";
import { DownloadList } from "../../../_patterns/03-components/downloadlist/DownloadList";
import { FacebookFeed } from "../../../_patterns/03-components/facebook-feed/FacebookFeed";
import { News } from "../../../_patterns/03-components/news/News";
import { OnlineVerification } from "../../../_patterns/03-components/online-verification/OnlineVerification";
import { TagList } from "../../../_patterns/03-components/tag-list/TagList";
import { Section } from "../../../_patterns/03-components/section/Section";
import { TitleBannerMagazine } from "../../../_patterns/03-components/title-banner-magazine/TitleBannerMagazine";
import { Text } from "../../../_patterns/03-components/text/Text";
import { Card } from "../../../_patterns/03-components/card/Card";
import { FatFooter } from "../../../_patterns/03-components/fat-footer/FatFooter";
import { ArticleHead } from "../../../_patterns/03-components/article-head/ArticleHead";
import { ArticleContent } from "../../../_patterns/03-components/article-content/ArticleContent";
import { Movie } from "../../../_patterns/03-components/movie/Movie";
import { RotatorSlide } from "../../../_patterns/03-components/rotator-slide/RotatorSlide";
import { WowSlider } from "../../../_patterns/03-components/wow-slider/WowSlider";
import { Form } from "../../../_patterns/03-components/form/Form";
import { SapmForm } from "../../../_patterns/03-components/sapm-form/SapmForm";
import { EnhancedNavigation } from "../../../_patterns/03-components/enhanced-navigation/js/EnhancedNavigation";
import { EnhancedDropDownLinkList } from "../../../_patterns/03-components/enhanced-navigation/js/EnhancedDropDownLinkList";
import { EnhancedNavigationHamburger } from "../../../_patterns/03-components/enhanced-navigation/js/EnhancedNavigationHamburger";
import { EnhancedHoverNavigation } from "../../../_patterns/03-components/enhanced-navigation/js/EnhancedHoverNavigation";
import { MicroHamburgerNavigation } from "../../../_patterns/03-components/enhanced-navigation/js/MicroHamburgerNavigation";
import { DropDownLinkList } from "../../../_patterns/03-components/dropdown-linklist/DropDownLinkList";
import { MainNavigation } from "../../../_patterns/03-components/main-navigation/MainNavigation";
import { NavBar } from "../../../_patterns/03-components/nav-bar/NavBar";
import { Flyout } from "../../../_patterns/03-components/flyout/Flyout";

// self-initializing via DOMContentLoaded guard (no initAll call needed)
import "../../../_patterns/02-molecules/lightbox/lightbox";
import "../../../_patterns/03-components/accordion-container/accordion-container";
import "../../../_patterns/03-components/image-gallery/ImageGallery";
import "../../../_patterns/03-components/rotator-container/RotatorContainer";
import "../../../_patterns/03-components/tab-container/Tabs";
import "../../../_patterns/03-components/teasergroup/TeaserGroup";
import "../../../_patterns/03-components/testimonial/Testimonial";

// self-initializing on load: binds its burger/overlay click handlers directly
import "../../../_patterns/03-components/simple-navigation/simple-navigation";



// In-house lazy-loading (drop-in replacement for lazysizes core + attrchange plugin).
import { initLazyLoad } from "../utils/lazyLoad";



// Start lazy-loading (handles `.lazyload` unveiling, `data-bg` backgrounds,
// and dynamically added elements).
initLazyLoad();

// ---------------------------------------------------------------------------
// ES6 module initialisation — explicit init() calls for better error isolation and ordering control.
// ---------------------------------------------------------------------------

  // function-based initialisers (run after T.Application.start() for ordering guarantees)
  initRotatorSectionRows(); // after breakpoint-hidden sections resolve
  initChannelList();        // after tabs fire
  initAuthorList();         // after tabs fire

  // ES6 classes — call initAll() on each, wrapping in Promise.resolve so both
  // sync (void) and async (Promise) initialisers get uniform error reporting.
  [
    // atoms
    PageController,
    // molecules
    TrackingController, MapModule, CourseFormFooter, CourseSession, NavFlyout, ShellNavigation, AnchorNavigationController, LightboxController,
    // components
    ArticleList, V2Searchfield,
    CtaUtmsContainer, DisclaimerPopup, CourseDetailV2, IFrame, Html5Module,
    ShareButtons, SiteSelector, BlurbV2, ButtonGroup, DownloadList,
    FacebookFeed, News, OnlineVerification, TagList,
    Section, TitleBannerMagazine, Text,
    Card, FatFooter, ArticleHead, ArticleContent, Movie, RotatorSlide, WowSlider,
    Form, SapmForm, EnhancedNavigation, EnhancedDropDownLinkList, EnhancedNavigationHamburger, EnhancedHoverNavigation, MicroHamburgerNavigation, DropDownLinkList, MainNavigation, NavBar, Flyout
  ].forEach(function (C) {
    Promise.resolve().then(() => C.initAll()).catch(function (err) {
      console.error("[" + C.name + "] initAll failed:", err);
    });
  });


// Generic-listing apps — async chunk, does not block the main bundle.
// Only loaded when the SSR flag marks this page as containing a listing component.
if (window.hasGenericListing) {
  import("../../../_patterns/03-components/generic-listing/generic-listing").catch(function (err) {
    console.error("[generic-listing] chunk load failed:", err);
  });
}

// Web Vitals measurement — async chunk, does not block main bundle
import("../utils/webVitals").catch(function (err) {
  console.error("[webVitals] chunk load failed:", err);
});
